import type { DirectiveBinding, ObjectDirective } from "vue";

const maskDirective: ObjectDirective = {
  // La directive est utilisée uniquement à l'insertion
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    const mask = binding.value;
    if (!mask) return;

    // Récupère l'input natif : soit `el` est un input, soit un conteneur
    const input = el.tagName === "INPUT" ? (el as HTMLInputElement) : el.querySelector("input");
    if (!input || !(input instanceof HTMLInputElement)) return;

    // #476 - Accepter les separateurs du masque saisis par l'utilisateur
    // Avant : replace(/\D/g, "") supprimait tous les non-chiffres, y compris les separateurs
    // (tirets, slashs, points) que l'utilisateur tapait volontairement.
    const separators = [...new Set(mask.replace(/9/g, ""))];
    const allowedPattern = new RegExp(`[^0-9${separators.map(s => "\\" + s).join("")}]`, "g");

    input.addEventListener("input", function () {
      const value = input.value.replace(allowedPattern, "");
      let maskedValue = "";
      let maskIndex = 0;

      for (let i = 0; i < value.length && maskIndex < mask.length; i++) {
        if (mask[maskIndex] === "9") {
          if (/\d/.test(value[i])) {
            maskedValue += value[i];
            maskIndex++;
          }
          // Si l'utilisateur a tape un separateur a une position de chiffre, on l'ignore
        }
        else {
          maskedValue += mask[maskIndex];
          maskIndex++;
          if (value[i] !== mask[maskIndex - 1]) {
            i--;
          }
        }
      }

      maskedValue = maskedValue.slice(0, mask.length);

      if (input.value !== maskedValue) {
        input.value = maskedValue;
        const event = new Event("input", { bubbles: true });
        input.dispatchEvent(event);
      }
    });
  },
};

export default maskDirective;
